// src/components/forms/register/NextOfKinSection.jsx
import React, { useState } from 'react';
import { User, Users, Mail, Phone, Hash } from 'lucide-react';
import { InputField } from '../shared/InputField';

export const NextOfKinSection = ({ formData, setFormData }) => {
  const isStudent = formData.role === "student";

  // Ensure nextOfKin is always an object inside studentInfo/staffInfo
  const kinPath = isStudent
    ? formData.studentInfo?.nextOfKin || {}
    : formData.staffInfo?.nextOfKin || {};

  const [errors, setErrors] = useState({
    name: '',
    relation: '',
    email: '',
    phone: ''
  });

  const updateKin = (field, value) => {
    setFormData({
      ...formData,
      [isStudent ? "studentInfo" : "staffInfo"]: {
        ...formData[isStudent ? "studentInfo" : "staffInfo"],
        nextOfKin: {
          ...kinPath, // Spread existing kin data
          [field]: value,
        },
      },
    });
  };

  // Validation functions
  const validateRequired = (field, value, label) => {
    if (!value) {
      setErrors(prev => ({ ...prev, [field]: `${label} is required` }));
      return false;
    } else {
      setErrors(prev => ({ ...prev, [field]: '' }));
      return true;
    }
  };

  const validateEmail = (value) => {
    // Email is optional, only validate format if provided
    if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setErrors(prev => ({ ...prev, email: 'Please enter a valid email address' }));
      return false;
    } else {
      setErrors(prev => ({ ...prev, email: '' }));
      return true;
    }
  };


  const validatePhone = (value) => {
    if (!value) {
      setErrors(prev => ({ ...prev, phone: 'Phone number is required' }));
      return false;
    } else if (!/^\+?[\d\s-]+$/.test(value)) {
      setErrors(prev => ({ ...prev, phone: 'Please enter a valid phone number' }));
      return false;
    } else {
      setErrors(prev => ({ ...prev, phone: '' }));
      return true;
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm space-y-4">
      <h3 className="text-lg font-medium text-gray-900 border-b pb-2">Next of Kin Information</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <InputField
          id="kinName"
          label="Full Name"
          required
          icon={<User className="h-5 w-5 text-gray-400" />}
          value={kinPath?.name || ""}
          onChange={(e) => {
            updateKin("name", e.target.value);
            if (errors.name) validateRequired('name', e.target.value, 'Full Name');
          }}
          validate={(value) => validateRequired('name', value, 'Full Name')}
          error={errors.name}
          placeholder="Jane Doe"
        />

        <InputField
          id="kinRelation"
          label="Relationship"
          required
          icon={<Users className="h-5 w-5 text-gray-400" />}
          value={kinPath?.relation || ""}
          onChange={(e) => {
            updateKin("relation", e.target.value);
            if (errors.relation) validateRequired('relation', e.target.value, 'Relationship');
          }}
          validate={(value) => validateRequired('relation', value, 'Relationship')}
          error={errors.relation}
          placeholder="Mother"
        />

        <InputField
          id="kinEmail"
          label="Email (Optional)"
          type="email"
          icon={<Mail className="h-5 w-5 text-gray-400" />}
          value={kinPath?.email || ""}
          onChange={(e) => {
            updateKin("email", e.target.value);
            if (errors.email) validateEmail(e.target.value);
          }}
          validate={validateEmail}
          error={errors.email}
          placeholder="jane.doe@example.com"
        />

        <InputField
          id="kinPhone"
          label="Phone Number"
          type="tel"
          required
          icon={<Phone className="h-5 w-5 text-gray-400" />}
          value={kinPath?.phone || ""}
          onChange={(e) => {
            updateKin("phone", e.target.value);
            if (errors.phone) validatePhone(e.target.value);
          }}
          validate={validatePhone}
          error={errors.phone}
          placeholder="+254712345678"
        />
      </div>
    </div>
  );
};

export default NextOfKinSection;

// export const NextOfKinSection = ({ formData, setFormData }) => {
//   const isStudent = formData.role === "student";

//   // Ensure nextOfKin is always an object inside studentInfo/staffInfo
//   const kinPath = isStudent
//     ? formData.studentInfo?.nextOfKin || {}
//     : formData.staffInfo?.nextOfKin || {};

//   const updateKin = (field, value) => {
//     setFormData({
//       ...formData,
//       [isStudent ? "studentInfo" : "staffInfo"]: {
//         ...formData[isStudent ? "studentInfo" : "staffInfo"],
//         nextOfKin: {
//           ...kinPath, // Spread existing kin data
//           [field]: value,
//         },
//       },
//     });
//   };

//   return (
//     <div className="bg-white p-6 rounded-lg shadow-sm space-y-4">
//       <h3 className="text-lg font-medium text-gray-900 border-b pb-2">Next of Kin Information</h3>

//       <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//         <InputField
//           id="kinName"
//           label="Full Name"
//           required
//           icon={<User className="h-5 w-5 text-gray-400" />}
//           value={kinPath?.name || ""}
//           onChange={(e) => updateKin("name", e.target.value)}
//         />

//         <InputField
//           id="kinRelation"
//           label="Relationship"
//           required
//           icon={<Users className="h-5 w-5 text-gray-400" />}
//           value={kinPath?.relation || ""}
//           onChange={(e) => updateKin("relation", e.target.value)}
//         />

//         <InputField
//           id="kinEmail"
//           label="Email"
//           type="email"
//           icon={<Mail className="h-5 w-5 text-gray-400" />}
//           value={kinPath?.email || ""}
//           onChange={(e) => updateKin("email", e.target.value)}
//         />

//         <InputField
//           id="kinPhone"
//           label="Phone Number"
//           type="tel"
//           required
//           icon={<Phone className="h-5 w-5 text-gray-400" />}
//           value={kinPath?.phone || ""}
//           onChange={(e) => updateKin("phone", e.target.value)}
//         />
//       </div>
//     </div>
//   );
// };

// export default NextOfKinSection;
